import { render, staticRenderFns } from "./screening-dialog-footer.vue?vue&type=template&id=affbbcfe&scoped=true"
import script from "./screening-dialog-footer.vue?vue&type=script&lang=js"
export * from "./screening-dialog-footer.vue?vue&type=script&lang=js"
import style0 from "./screening-dialog-footer.vue?vue&type=style&index=0&id=affbbcfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affbbcfe",
  null
  
)

export default component.exports